<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Stater Page</h5>
                  </div>
                  <small class="text-truncate text-muted"></small>
                </div>
              </div>
            </div>
            <div class="col-7 col-xl-8 text-end">

            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <div class="row">
            <div class="col-lg-12 mt-5 mb-4">
              <div class="card">
                <div class="card-body">
                  <pre><code class="language-html">&lt;!DOCTYPE html&gt;
    &lt;html lang=&quot;en&quot;&gt;
    &lt;meta charset=&quot;utf-8&quot;&gt;
    &lt;meta http-equiv=&quot;X-UA-Compatible&quot; content=&quot;IE=Edge&quot;&gt;
    &lt;meta name=&quot;viewport&quot; content=&quot;width=device-width, initial-scale=1, shrink-to-fit=no&quot;&gt;
    &lt;meta name=&quot;description&quot; content=&quot;Responsive Bootstrap 4 and web Application ui kit.&quot;&gt;

    &lt;title&gt;:: PostMan :: Stater page&lt;/title&gt;
    &lt;link rel=&quot;icon&quot; href=&quot;favicon.ico&quot; type=&quot;image/x-icon&quot;/&gt;
    &lt;!-- Material Design Iconic Font --&gt;
    &lt;link rel=&quot;stylesheet&quot; href=&quot;../fonts/material-icon/css/material-design-iconic-font.min.css&quot;&gt;
    &lt;link rel=&quot;stylesheet&quot; href=&quot;assets/vendor/bootstrap-datepicker/css/bootstrap-datepicker.min.css&quot;&gt;

    &lt;!-- MAIN CSS --&gt;
    &lt;link rel=&quot;stylesheet&quot; href=&quot;assets/css/style.min.css&quot;&gt;

    &lt;!-- This is demo css  --&gt;
    &lt;link rel=&quot;stylesheet&quot; href=&quot;../doc/demo.css&quot;&gt;

    &lt;body class=&quot;admin&quot;&gt;

    &lt;div id=&quot;layout&quot; class=&quot;theme-cyan&quot;&gt;

        &lt;!-- Navbar --&gt;
        &lt;div class=&quot;navigation navbar justify-content-center py-xl-4 py-md-3 py-0 px-3&quot;&gt;

        &lt;/div&gt;
        &lt;!-- End Navbar --&gt;

        &lt;!-- Sidebar --&gt;
        &lt;div class=&quot;sidebar border-end py-xl-4 py-3 px-xl-4 px-3&quot;&gt;

        &lt;/div&gt;
        &lt;!-- End Sidebar --&gt;

        &lt;!-- Rightbar icon menu --&gt;
        &lt;div class=&quot;rightbar d-none d-md-block&quot;&gt;

        &lt;/div&gt;
        &lt;!-- End Rightbar icon menu --&gt;

        &lt;!-- Main Body: Content --&gt;
        &lt;div class=&quot;main px-xl-5 px-lg-4 px-3&quot;&gt;

            &lt;!-- Body --&gt;
            &lt;div class=&quot;main-body&quot;&gt;

                &lt;!-- Body: Header --&gt;
                &lt;div class=&quot;body-header border-bottom py-xl-3 py-2&quot;&gt;
                    &lt;div class=&quot;container px-0&quot;&gt;

                        &lt;div class=&quot;row align-items-center&quot;&gt;

                            &lt;!-- page title --&gt;
                            &lt;div class=&quot;col-5 col-xl-4&quot;&gt;
                                &lt;div class=&quot;media&quot;&gt;
                                    &lt;div class=&quot;media-body overflow-hidden&quot;&gt;
                                        &lt;div class=&quot;d-flex align-items-center justify-content-between mb-1&quot;&gt;
                                            &lt;h5 class=&quot;text-truncate mb-0 me-auto&quot;&gt;Stater Page&lt;/h5&gt;
                                        &lt;/div&gt;
                                        &lt;small class=&quot;text-truncate text-muted&quot;&gt;&lt;/small&gt;
                                    &lt;/div&gt;
                                &lt;/div&gt;
                            &lt;/div&gt;
                            &lt;div class=&quot;col-7 col-xl-8 text-end&quot;&gt;

                            &lt;/div&gt;
                        &lt;/div&gt;

                    &lt;/div&gt;
                &lt;/div&gt;

                &lt;!-- Page Default --&gt;
                &lt;div class=&quot;body-page d-flex py-xl-3 py-2&quot;&gt;
                    &lt;div class=&quot;container px-0&quot;&gt;

                    &lt;/div&gt;
                &lt;/div&gt;
                &lt;!-- End Page Default --&gt;

            &lt;/div&gt;
            &lt;!-- End chat body --&gt;

        &lt;/div&gt;
        &lt;!-- Main Body: Content --&gt;

    &lt;/div&gt;


    &lt;!-- Main jQuery js Bootstrap core js file --&gt;
    &lt;script src=&quot;assets/vendor/jquery/jquery-3.5.1.min.js&quot;&gt;&lt;/script&gt;
    &lt;script src=&quot;assets/vendor/bootstrap/js/bootstrap.bundle.min.js&quot;&gt;&lt;/script&gt;

    &lt;!-- Plugin js file --&gt;
    &lt;script src=&quot;assets/vendor/bootstrap-datepicker/js/bootstrap-datepicker.min.js&quot;&gt;&lt;/script&gt;

    &lt;!-- Project core file --&gt;
    &lt;script src=&quot;../js/template.js&quot;&gt;&lt;/script&gt;
    &lt;/body&gt;
    &lt;/html&gt;</code></pre>
                </div>
              </div>
            </div>
          </div> <!-- .row end -->

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
